import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserTeamMasterService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  getUsersFromGovevaForDefaultUserSelection() {
    var request = {
        URL: "userMaster/getInternalUserList"            
    }
    return this.httpService.getGovEvaCall(request);
  }

  addUserTeamMaster(usersData) {
    var request = {
        URL: 'userTeamMaster/add',
        DATA: usersData
    }
  return this.httpService.post(request);
  }

  getUserTeamMasterData() {
    var request = {
        URL: 'userTeamMaster/getData'
    }
    return this.httpService.get(request);
  }

  editUserTeamMaster(usersData, _id) {
    var request = {
        URL: "userTeamMaster/edit/" + _id,
        DATA: usersData
    }
    return this.httpService.post(request)
  }

  

}
